import React, { ReactNode } from 'react';
import { useUI, UIProvider } from './UIContext';
import { useAuth, AuthProvider } from './AuthContext';
import { useData, DataProvider } from './DataContext';

// Re-export types for backward compatibility
export * from '../types';

// valid hook usage
export const useSiteContent = () => {
  const ui = useUI();
  const auth = useAuth();
  const data = useData();

  return {
    ...ui,
    ...auth,
    ...data
  };
};

export const SiteProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <UIProvider>
      <AuthProvider>
        <DataProvider>
          {children}
        </DataProvider>
      </AuthProvider>
    </UIProvider>
  );
};